$(document).ready(function() {
  /*================ select style =================*/
  $('.collection .page-header select').selectric({
    maxHeight: 350
  });

  /*================ fade in effect =================*/
  $('body').css('opacity', '1');
  
  /*================ Keep footer at bottom =================*/
  
  $('html').css('height', '100%');
  var htmlHeight = $('html').outerHeight();
  var bodyHeight = $('body').outerHeight();
  
  var mainContentHeight = htmlHeight - $('footer.site-footer').outerHeight() - $('header.header').outerHeight() + 100;
  
  if (bodyHeight < htmlHeight) {
    $('footer.site-footer').css({"position": "absolute", "left": "0", "width": "100%", "bottom": "0"});
  
    $('.main-content').css('height', mainContentHeight);
  }
  
  /*================ Header scroll =================*/
  if ($(window).scrollTop() > 0) {
    $("header.header").addClass("isScroll");
  } else {
    $("header.header").removeClass("isScroll");
  }
  $(window).bind("scroll", function () {
    if ($(window).scrollTop() > 0) {
      $("header.header").addClass("isScroll");
    } else {
      $("header.header").removeClass("isScroll");
    }
  });
  
  /*================ Header hover =================*/
  $("header.header").mouseover(function() {
    $(this).addClass("isHover");
  });
  $("header.header").mouseleave(function() {
    $(this).removeClass("isHover");
  });
  
});